module.exports = __webpack_public_path__ + "static/img/right-top-row-5.9556635c.webp";